import dashboard from "./Dashboard";
import apps from "./Apps";

export default [...dashboard, ...apps];
